import { configureStore } from "@reduxjs/toolkit";
import { reducer, initialState } from "./reducer";

export const store = configureStore({
  reducer,
  preloadedState: initialState,
});

// Синхронизация sessionId в localStorage при каждом изменении user
store.subscribe(() => {
  const state = store.getState();
  const sessionId = state.user?.sessionId ?? "";
  localStorage.setItem("sessionId", sessionId);
});
